import React from 'react';
import { Form, Select, Space } from 'antd';
import { FormattedMessage } from 'react-intl';

import Flag from 'components/Flag';
import messages from './messages';

const getWebsiteUrlOptions = website => {
  const productionUrls = [{
    value: website.id,
    searchValue: website.url,
    label: (
      <Space>
        {website.language && <Flag locale={website.language} />}
        <span>{website.url}</span>
      </Space>
    ),
  },
  ...(website.additionalLanguages || []).map(language => ({
    value: language.id,
    searchValue: language.url,
    label: (
      <Space>
        {language.language && <Flag locale={language.language} />}
        <span>{language.url}</span>
      </Space>
    ),
  }))];
  const testingUrls = website.additionalUrls?.map(url => ({
    value: url,
    searchValue: url,
    label: url,
  })) || [];

  return { productionUrls, testingUrls };
};

const getWebsitesUrlOptions = websites => {
  if (!websites?.length) {
    return [];
  }

  const productionUrls = [];
  const testingUrls = [];

  websites.forEach(website => {
    const { productionUrls: websiteProductionUrls, testingUrls: websiteTestingUrls } = getWebsiteUrlOptions(website);
    productionUrls.push(...websiteProductionUrls);
    testingUrls.push(...websiteTestingUrls);
  });

  if (productionUrls.length === 1 && testingUrls.length === 0) {
    return [];
  }

  if (productionUrls.length > 1) {
    productionUrls.splice(0, 0, {
      label: 'All live URLs',
      value: 'production',
    });
  }

  const options = [{
    label: 'Live URLs',
    options: productionUrls,
  }];

  if (testingUrls.length) {
    if (testingUrls.length > 1) {
      testingUrls.splice(0, 0, {
        label: 'All testing URLs',
        value: 'testing',
      });
    }

    options.push({
      label: 'Testing URLs',
      options: testingUrls,
    });
  }

  return options;
};

const WebsiteUrlSelector = ({ websites }) => {
  const options = getWebsitesUrlOptions(websites);

  if (options.length === 0) {
    return null;
  }

  return (
    <Form.Item name="websiteBaseUrls" label={<FormattedMessage {...messages.websiteUrlScopeLabel} />}>
      <Select
        mode="multiple"
        options={options}
        showSearch
        placeholder="All urls"
        filterOption={(input, option) => (option.searchValue || option.value)?.toLowerCase().includes(input.toLowerCase())}
      />
    </Form.Item>
  );
};

export default WebsiteUrlSelector;
